import { render, staticRenderFns } from "./surroundBox.vue?vue&type=template&id=1c3d0c6c&scoped=true"
import script from "./surroundBox.vue?vue&type=script&lang=js"
export * from "./surroundBox.vue?vue&type=script&lang=js"
import style0 from "./surroundBox.vue?vue&type=style&index=0&id=1c3d0c6c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3d0c6c",
  null
  
)

export default component.exports